'use strict';

var _ = require('lodash');
var MergeScenarioDataService = function MergeScenarioDataService(overridesUtilsService, JQXGridCellTreatementTrendConstants) {
  var TREND_UP = 'trend-up';
  var TREND_DOWN = 'trend-down';
  var USER_MODIFIED = 'user-modified';
  var TREND_UP_PREVIEW = 'trend-up-preview';
  var TREND_DOWN_PREVIEW = 'trend-down-preview';
  var NON_NUMERIC_VALUES_CHANGES_PREVIEW = 'non-numeric-values-changes-preview';

  /**
   * Rewrites production properties with scenario properties.
   * @param productionRecord
   * @param scenarioRecord
   */
  function rewrite(productionRecord, scenarioRecord) {
    _.forIn(scenarioRecord, function (value, key) {
      var scenarioValue = scenarioRecord[key];
      var productionValue = productionRecord[key];
      var scenarioValueDefined = scenarioValue !== undefined;
      var productionValueDefined = productionValue !== undefined;
      var isScenarioValueNumeric = scenarioValueDefined && _.isNumber(scenarioValue) && !_.isNaN(scenarioValue);
      var isProductionValueNumeric = productionValueDefined && _.isNumber(productionValue) && !_.isNaN(productionValue);
      if (scenarioValueDefined && productionValue !== scenarioValue) {
        productionRecord[key] = scenarioValue;
        if (overridesUtilsService.isUserField(key)) {
          _.set(productionRecord, 'customClasses.' + key, USER_MODIFIED);
          productionRecord.userScenarioModified = true;
        } else if (!overridesUtilsService.isEffective(key) && isScenarioValueNumeric && isProductionValueNumeric) {
          _.set(productionRecord, 'customClasses.' + key, scenarioValue > productionValue ? TREND_UP : TREND_DOWN);
        }
      }
    });
  }

  /**
   * Modifies the content of the passed array.
   * PUBLISHED records (from productionData) are altered with scenario values.
   * @param productionData
   * @param scenarioData
   * @returns {Array}
   */
  function merge(productionData, scenarioData) {
    if (!_.isArray(scenarioData) || scenarioData.length === 0) {
      return productionData;
    }
    var scenarioDataMap = _.keyBy(scenarioData, 'entryKey');
    for (var i = 0; i < productionData.length; i++) {
      var record = productionData[i];
      var scenarioRecord = scenarioDataMap[record.entryKey];
      if (scenarioRecord !== undefined) {
        rewrite(record, scenarioRecord);
      }
    }
    return productionData;
  }
  function markScenarioPreviewTrends(productionRow, previewScenarioRow, trendProperties) {
    _.forEach(trendProperties, function (prop) {
      if (!_.isFinite(previewScenarioRow[prop]) || !_.isFinite(productionRow[prop])) {
        return;
      }
      if (previewScenarioRow[prop] > productionRow[prop]) {
        _.set(productionRow, 'customClasses.' + prop, TREND_UP_PREVIEW);
      } else if (previewScenarioRow[prop] < productionRow[prop]) {
        _.set(productionRow, 'customClasses.' + prop, TREND_DOWN_PREVIEW);
      }
    });
  }
  function markScenarioPreviewNonNumericValuesChanges(productionRow, previewScenarioRow) {
    var nonNumericValuesProperties = JQXGridCellTreatementTrendConstants.NON_NUMERIC_VALUES_PROPERTIES;
    _.forEach(nonNumericValuesProperties, function (prop) {
      if (previewScenarioRow[prop] !== productionRow[prop]) {
        _.set(productionRow, 'customClasses.' + prop, NON_NUMERIC_VALUES_CHANGES_PREVIEW);
      }
    });
  }
  function rewritePreviewScenario(productionRow, previewScenarioRow, trendProperties) {
    markScenarioPreviewNonNumericValuesChanges(productionRow, previewScenarioRow);
    markScenarioPreviewTrends(productionRow, previewScenarioRow, trendProperties);
    var dirty = false;
    _.forEach(previewScenarioRow, function (value, key) {
      if (!_.isUndefined(value) && productionRow[key] !== value) {
        if (key === 'customClasses') {
          productionRow[key] = _.merge(value, productionRow[key]);
        } else {
          productionRow[key] = value;
        }
        dirty = true;
      }
    });
    if (dirty) {
      return productionRow;
    }
  }
  function mergePreviewScenario(productionData, scenarioData, gridId) {
    var result = [];
    var trends = JQXGridCellTreatementTrendConstants.GRID_TRENDS[gridId];
    if (!_.isArray(scenarioData) || scenarioData.length === 0) {
      return result;
    }
    var scenarioDataMap = _.keyBy(scenarioData, 'entryKey');
    return _.chain(productionData).reduce(function (result, productionRecord) {
      var scenarioRecord = scenarioDataMap[productionRecord.entryKey];
      if (scenarioRecord !== undefined) {
        result.push(rewritePreviewScenario(productionRecord, scenarioRecord, trends));
      }
      return result;
    }, result).compact().value();
  }
  return {
    merge: merge,
    mergePreviewScenario: mergePreviewScenario
  };
};
MergeScenarioDataService.$inject = ['OverridesUtilsService', 'JQXGridCellTreatementTrendConstants'];
module.exports = MergeScenarioDataService;